/* eslint-disable import/prefer-default-export */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Button, Center, Loader, Text, TextInput } from '@mantine/core';
import { closeAllModals, openModal } from '@mantine/modals';
import { i18n } from '@lingui/core';
import { FC, useEffect, useState } from 'react';
import { IconTemplate } from '@tabler/icons';
import { useNavigate } from 'react-router-dom';
import { AgencyTemplateS } from '../../../../Service/AgencyTemplateS';
import { AgencyTemplateDTO, CreateAgencyTemplateDto } from '../../../../Types/MessageT';

interface CreateModalProps {
  existingNames?: string[];
  templateDto?: CreateAgencyTemplateDto;
}

export const openCreateTemplateModal = (props: CreateModalProps) =>
  openModal({
    title: (
      <Text weight="bolder" size="xl">
        Vorlage erstellen
      </Text>
    ),
    children: <CreateTemplateModal {...props} />,
  });

const CreateTemplateModal: FC<CreateModalProps> = ({ existingNames: initialExistingNames, templateDto }) => {
  const [loading, setLoading] = useState(false);
  const [existingNames, setExistingNames] = useState<string[]>(initialExistingNames ?? []);
  const [name, setName] = useState('');
  const navigate = useNavigate();
  const conflict = existingNames.includes(name);

  useEffect(() => {
    if (!initialExistingNames) {
      // Fetch only if not provided
      AgencyTemplateS.getAllNames().then(setExistingNames);
    }
  }, [initialExistingNames]);

  const createTemplate = async () => {
    setLoading(true);
    const resJSON = await AgencyTemplateS.create(name, templateDto);
    setLoading(false);
    if (resJSON) {
      closeAllModals();
      if (!templateDto) navigate(`/settings/agency/message/${resJSON.id}`);
    }
  };

  return (
    <>
      <TextInput
        value={name}
        icon={<IconTemplate size={20} />}
        label="Name"
        onChange={(e) => setName(e.currentTarget.value)}
        disabled={loading}
        error={conflict && 'Name ist bereits vergeben'}
      />
      <Center mt={30}>
        <Button
          disabled={name === '' || conflict || loading}
          onClick={createTemplate}
          rightIcon={loading && <Loader size="xs" />}
          sx={{ minWidth: 250 }}
        >
          {i18n._('actions.save')}
        </Button>
      </Center>
    </>
  );
};

interface EditModalProps {
  template: AgencyTemplateDTO;
  onChange: (template: AgencyTemplateDTO) => void;
  initialExistingNames?: string[];
}

export const openEditTemplateModal = (props: EditModalProps) =>
  openModal({
    title: (
      <Text weight="bolder" size="xl">
        Vorlage bearbeiten
      </Text>
    ),
    children: <EditTemplateModal {...props} />,
  });

const EditTemplateModal: FC<EditModalProps> = ({ template, initialExistingNames, onChange }) => {
  const { id, name: initialName } = template;
  const [loading, setLoading] = useState(false);
  const [existingNames, setExistingNames] = useState<string[]>(initialExistingNames ?? []);
  const [name, setName] = useState(initialName);
  const conflict = name !== initialName && existingNames.includes(name);

  useEffect(() => {
    if (!initialExistingNames) {
      // Fetch only if not provided
      AgencyTemplateS.getAllNames().then(setExistingNames);
    }
  }, [initialExistingNames]);

  const editTemplate = async () => {
    setLoading(true);
    const resJSON = await AgencyTemplateS.edit(id, { name });
    setLoading(false);
    if (resJSON) {
      onChange(resJSON);
      closeAllModals();
    }
  };

  return (
    <>
      <TextInput
        value={name}
        icon={<IconTemplate size={20} />}
        label="Name"
        onChange={(e) => setName(e.currentTarget.value)}
        disabled={loading}
        error={conflict && 'Name ist bereits vergeben'}
      />
      <Center mt={30}>
        <Button
          disabled={name === initialName || name === '' || conflict || loading}
          onClick={editTemplate}
          rightIcon={loading && <Loader size="xs" />}
          sx={{ minWidth: 250 }}
        >
          {i18n._('actions.edit')}
        </Button>
      </Center>
    </>
  );
};
